import { styleInspirations } from '@/mocks/laceData';

export default function StyleInspiration() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="mx-auto" style={{ maxWidth: '1280px' }}>
        <div className="text-center mb-12">
          <p className="text-accent-600 text-sm tracking-[0.2em] uppercase mb-3 font-label">Style Inspiration</p>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
            蕾丝搭配灵感
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            从法式浪漫到现代简约，探索蕾丝在不同风格中的多样演绎，为你的穿搭注入灵感。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {styleInspirations.map((item) => (
            <div key={item.title} className="group cursor-pointer">
              <div className="relative h-80 md:h-96 overflow-hidden rounded-lg mb-4">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <h3 className="absolute bottom-4 left-4 right-4 font-heading text-lg font-semibold text-background-50">
                  {item.title}
                </h3>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed px-1">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}